import styled from '@mui/system/styled';

export const MentionedContainer = styled('div')({
  '& .mentioned-title': {
    marginBottom: '30px'
  }
});

export default MentionedContainer;
